import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneOtherProjectSupport = createAsyncThunk(
  "OneOtherProjectSupport/OneGetOtherProjectSupport",
  async (tE_OS_OtherSupportingOrganizationsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_OS_OtherSupportingOrganizations/GetTE_OS_OtherSupportingOrganizationsData",
        {
          tE_OS_OtherSupportingOrganizationsId:
            tE_OS_OtherSupportingOrganizationsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateOtherProjectSupport = createAsyncThunk(
  "OtherProjectSupport/ValidateOtherProjectSupport",
  async (OtherProjectSupport, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_OS_OtherSupportingOrganizations/ValidateTE_OS_OtherSupportingOrganizations",
        {
          organizationName: OtherProjectSupport.organizationName,
          tE_OS_NatureOfSupportId: OtherProjectSupport.tE_OS_NatureOfSupportId,
          supportDetails: OtherProjectSupport.supportDetails,
          supportAmountIfMonetary: OtherProjectSupport.supportAmountIfMonetary,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneOtherProjectSupport = createSlice({
  name: "OneOtherProjectSupport ",
  initialState: {
    OneOtherProjectSupport: {},
    loadingOneOtherProjectSupport: false,
    errorOneOtherProjectSupport: null,

    OtherProjectSupportValidate: [],
    loadingOtherProjectSupportValidate: false,
    errorOtherProjectSupportValidateValidate: null,
  },
  reducers: {
    restValidationOtherProjectSupport : (state,action)=>{
      state.OtherProjectSupportValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneOtherProjectSupport.pending, (state, action) => {
        state.loadingOneOtherProjectSupport = true;
        state.OneOtherProjectSupport = action.payload;
        state.errorOneOtherProjectSupport = null;
      })
      .addCase(GetOneOtherProjectSupport.fulfilled, (state, action) => {
        state.loadingOneOtherProjectSupport = false;
        state.OneOtherProjectSupport = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneOtherProjectSupport.rejected, (state, action) => {
        state.loadingOneOtherProjectSupport = false;
        state.errorOneOtherProjectSupport = action.payload;
      })

      .addCase(ValidateOtherProjectSupport.pending, (state, action) => {
        state.loadingOtherProjectSupportValidate = true;
        state.OtherProjectSupportValidate = action.payload;
        state.errorOtherProjectSupportValidateValidate = null;
      })
      .addCase(ValidateOtherProjectSupport.fulfilled, (state, action) => {
        state.loadingOtherProjectSupportValidate = false;
        state.OtherProjectSupportValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateOtherProjectSupport.rejected, (state, action) => {
        state.loadingOtherProjectSupportValidate = false;
        state.errorOtherProjectSupportValidateValidate = action.payload;
      });
  },
});
export const { restValidationOtherProjectSupport } = OneOtherProjectSupport.actions;
export default OneOtherProjectSupport.reducer;
